import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: "final-grades",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-gradebook" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
